/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LogoSettings} from '../models/LogoSettings';
import type {SettingsType} from '../models/SettingsType';

export interface GetLogoSettings$Request {
    conferenceId: number;
    settingsType: SettingsType;
}

export interface GetLogoSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLogoSettingsRequest = createAction<PayloadData<void, GetLogoSettings$Request>>('CONFERENCE_LOGO__GET_LOGO_SETTINGS__REQUEST');
export const getLogoSettingsSuccess = createAction<PayloadData<LogoSettings, GetLogoSettings$Request>>('CONFERENCE_LOGO__GET_LOGO_SETTINGS__SUCCESS');
export const getLogoSettingsFailure = createAction<PayloadData<Error, GetLogoSettings$Request, true>>('CONFERENCE_LOGO__GET_LOGO_SETTINGS__FAILURE');

export const getLogoSettingsActions = [
    getLogoSettingsRequest,
    getLogoSettingsSuccess,
    getLogoSettingsFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {SettingsType} meta.settingsType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLogoSettings = (meta: GetLogoSettings$Request, config?: GetLogoSettings$Config) => {
    return {
        CALL_API: {
            types: getLogoSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/conferences/${meta.conferenceId}/logos/${meta.settingsType}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveLogoSettings$Request {
    conferenceId: number;
    settingsType: SettingsType;
    link?: string;
    logo?: File | File[];
}

export interface SaveLogoSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
    onProgress?: (progress: ProgressEvent) => void;
}

export const saveLogoSettingsRequest = createAction<PayloadData<void, SaveLogoSettings$Request>>('CONFERENCE_LOGO__SAVE_LOGO_SETTINGS__REQUEST');
export const saveLogoSettingsSuccess = createAction<PayloadData<void, SaveLogoSettings$Request>>('CONFERENCE_LOGO__SAVE_LOGO_SETTINGS__SUCCESS');
export const saveLogoSettingsFailure = createAction<PayloadData<Error, SaveLogoSettings$Request, true>>('CONFERENCE_LOGO__SAVE_LOGO_SETTINGS__FAILURE');

export const saveLogoSettingsActions = [
    saveLogoSettingsRequest,
    saveLogoSettingsSuccess,
    saveLogoSettingsFailure
] as const;

/**
 * @param {number} meta.conferenceId The conference id
 * @param {SettingsType} meta.settingsType
 * @param {string} [meta.link]
 * @param {any} [meta.logo]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 * @param {function(ProgressEvent): void} [config.onProgress]
 */
export const saveLogoSettings = (meta: SaveLogoSettings$Request, config?: SaveLogoSettings$Config) => {
    const TRANSPORT_REQUEST_FILE = {
        link: meta.link,
        logo: meta.logo,
    };
    return {
        UPLOAD_FILE: {
            types: saveLogoSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/conferences/${meta.conferenceId}/logos/${meta.settingsType}`,
            TRANSPORT_REQUEST_FILE,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            onProgress: config?.onProgress,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

